var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftInputArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9231 26.2546C14.786 25.3175 14.786 23.8038 13.9231 22.8667L5.33816 13.544L13.9231 4.22129C14.786 3.28421 14.786 1.77047 13.9231 0.833397C13.0602 -0.10368 11.6663 -0.10368 10.8033 0.833397L0.647411 11.8621C-0.21551 12.7991 -0.21551 14.3129 0.64741 15.25L10.8033 26.2786C11.6441 27.1917 13.0602 27.1917 13.9231 26.2546Z",
    fill: "#FF3152"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftInputArrowIcon);
export default __webpack_public_path__ + "static/media/left_input_arrow_icon.3fb049fe7cbd94a15142a93b04f14ee5.svg";
export { ForwardRef as ReactComponent };